module.exports = __webpack_public_path__ + "static/media/cafe24.484b0761.png";